import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import EditIcon from '@mui/icons-material/Edit';
import {
    StySynthesisHeader,
    StyName,
} from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/components/SynthesisHeader/StyComponents';

function SynthesisHeaderLoader(): React.ReactElement {
    return (
        <StySynthesisHeader>
            <StyName>
                <ArrowBackIosIcon fontSize="small" />
                <Typography variant="h5" sx={{ width: '12em' }}>
                    <Skeleton />
                </Typography>
                <EditIcon sx={{ margin: '1em' }} />
                <Skeleton
                    variant="rectangular"
                    sx={{ borderRadius: '20px', height: '2em', width: '5em' }}
                />
            </StyName>
        </StySynthesisHeader>
    );
}

export default SynthesisHeaderLoader;
